import { makeStyles } from "@material-ui/core/styles";
import styled from "@emotion/styled";
import { units } from "../../../../types/units";
import { FormLabel, Typography } from "@material-ui/core";

export const useFlyerListCurrentHeaderStyles = makeStyles(() => ({
  noWrap: {
    "white-space": "nowrap",
  },
}));
export const CurrentHeader = styled(Typography)`
  ${units({
    fontSize: "1.5rem",
    marginLeft: "16px",
    marginBottom: "20px",
  })}
`;

export const ViewLabel = styled(FormLabel)`
  display: none;
`;
